/* ==========================================================================
   pdp-ship-countdown.js — <ship-countdown>

   Honest same-day-ship cutoff clock. A REAL daily fulfillment deadline:
   12:00 PM America/Chicago (CT), Monday–Friday. This is not invented scarcity
   (which the brand bans) — it's a true operational fact, so it's on-brand.

     • Business day, before 12:00 PM CT → live ticking countdown ("ships today").
     • After cutoff / weekend / holiday → calm "Ships <next business day>",
       no urgency clock.

   NOT the theme's fixed-date `countdown` block. Additive + reversible.
   Degrades to the snippet's static fallback line when JS is off.
   ========================================================================== */
(function () {
  if (customElements.get('ship-countdown')) return;

  var CUTOFF_HOUR = 12;               // noon CT
  var TZ = 'America/Chicago';         // Des Moines, IA = Central Time
  var HOLIDAYS = [];                  // 'YYYY-MM-DD' CT dates we don't ship. Populate when supplied.
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function pad(n) { return String(n).padStart(2, '0'); }

  // Current wall-clock in CT, DST handled by Intl.
  function ctParts(date) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var o = {};
    fmt.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return {
      y: parseInt(o.year, 10),
      m: parseInt(o.month, 10),
      d: parseInt(o.day, 10),
      hour: parseInt(o.hour, 10) % 24,  // some engines emit '24' at midnight
      minute: parseInt(o.minute, 10),
      second: parseInt(o.second, 10)
    };
  }

  // Date-only anchor at noon UTC so weekday math never drifts across time zones.
  function anchor(y, m, d) { return new Date(Date.UTC(y, m - 1, d, 12)); }
  function iso(dt) {
    return dt.getUTCFullYear() + '-' + pad(dt.getUTCMonth() + 1) + '-' + pad(dt.getUTCDate());
  }
  function isBusinessDay(dt) {
    var wd = dt.getUTCDay();
    if (wd === 0 || wd === 6) return false;         // Sun / Sat
    return HOLIDAYS.indexOf(iso(dt)) === -1;
  }
  function nextBusinessDay(dt) {
    var n = new Date(dt.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!isBusinessDay(n));
    return n;
  }

  class ShipCountdown extends HTMLElement {
    connectedCallback() {
      this.msgEl = this.querySelector('[data-ship-msg]');
      this.timeEl = this.querySelector('[data-ship-time]');
      this.tailEl = this.querySelector('[data-ship-tail]');
      this._tick = this.render.bind(this);
      this.render();
      this.timer = setInterval(this._tick, 1000);
    }
    disconnectedCallback() { if (this.timer) clearInterval(this.timer); }

    set(msg, time, tail) {
      if (this.msgEl) this.msgEl.textContent = msg;
      if (this.timeEl) this.timeEl.textContent = time;
      if (this.tailEl) this.tailEl.textContent = tail;
    }

    render() {
      var p = ctParts(new Date());
      var today = anchor(p.y, p.m, p.d);
      var secsNow = p.hour * 3600 + p.minute * 60 + p.second;
      var cutoff = CUTOFF_HOUR * 3600;

      if (isBusinessDay(today) && secsNow < cutoff) {
        var r = cutoff - secsNow;
        var h = Math.floor(r / 3600);
        var mi = Math.floor((r % 3600) / 60);
        var s = r % 60;
        var t = (h > 0 ? h + 'h ' : '') + mi + 'm ' + pad(s) + 's';
        this.classList.add('is-live');
        this.classList.remove('is-next');
        this.setAttribute('data-state', 'today');
        this.set('Order within', t, 'and it ships today.');
      } else {
        var ship = nextBusinessDay(today);
        var tomorrow = new Date(today.getTime());
        tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
        var label = iso(ship) === iso(tomorrow) ? 'tomorrow' : DAY_NAMES[ship.getUTCDay()];
        this.classList.remove('is-live');
        this.classList.add('is-next');
        this.setAttribute('data-state', 'next');
        this.set('Ships', label, '— order anytime.');
      }
    }
  }

  customElements.define('ship-countdown', ShipCountdown);
})();
